import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../../ui';
import { SharedUiModule } from '../../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { SLEntityService } from './entity.service';
import { SLEntityResolver } from './entity.resolver';
import { SLEntityListComponent } from './entity-list.component';
import { SLEntityEditComponent } from './entity-edit.component';
import { SLEntityFilterDialogComponent } from './entity-filter-dialog.component';
import { SLEntitySearchDialogComponent } from './entity-search-dialog.component';
import { SLEntityTypePipe } from './entity-type.pipe';
import { SLAddressPipe } from './address.pipe';
import { SLSharePipe } from './share.pipe';
import { SLMovementEditComponent } from './movement-edit.component';
import { SLMovementLineOperationPipe } from './movement-line-operation.pipe';
import { SLMovementLineOwnershipPipe } from './movement-line-ownership.pipe';
import { SLEntityNewDialogComponent } from './entity-new-dialog.component';
import { FileUploadModule } from 'ng2-file-upload';
import { SLAttachmentService } from './attachment.service';
import { SLEntityFormComponent } from './panels/entity-form.component';
import { SLMovementRegisterComponent } from './movement-register.component';
import { SLEntityDetailsComponent } from './panels/entity-details.component';
import { SLEntityInfosComponent } from './panels/entity-infos.component';
import { SLEntityVersionListComponent } from './entity-version-list.component';
import { SLEntityVersionResolver } from './entity-version.resolver';
import { SLEntityMovementsComponent } from './panels/entity-movements.component';
import { SLEntityVersionEditComponent } from './entity-version-edit.component';
import { SLEntityVersionVerifyComponent } from './entity-version-verify.component';
import { SLEntityBlockchainComponent } from './panels/entity-blockchain.component';
import { SLEntityMovementsLedgerComponent } from './panels/entity-movements-ledger.component';
import { SLEntityOwnedSharesComponent } from './panels/entity-owned-shares.component';
import { SLEntityShareholdersComponent } from './panels/entity-shareholders.component';
import { SLAuthorizationService } from './authorization.service';
import { SLAuthorizationListComponent } from './authorization-list.component';
import { SLMovementLineShareTypePipe } from './movement-line-share-type.pipe';
import { SLMovementLineNaturePipe } from './movement-line-nature.pipe';
import { SLEntityExtraFieldsFormComponent } from './panels/entity-extra-fields-form.component';
import { SLEntityExtraFieldsPanelComponent } from './panels/entity-extra-fields-panel.component';
import { SLMovementDismembermentDialogComponent } from './movement-dismemberment-dialog.component';
import { SLEntityLookupComponent } from './entity-lookup.component';
import { SLEntityAttachmentsComponent } from './panels/entity-attachments.component';
import { SLMovementWritingDatePipe } from './movement-writing-date.pipe';
import { SLAccountBalanceItemsPipe } from './account-balance-items.pipe';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    FileUploadModule,
  ],
  declarations: [
    SLEntityListComponent,
    SLEntityEditComponent,
    SLEntityFilterDialogComponent,
    SLEntitySearchDialogComponent,
    SLEntityNewDialogComponent,
    SLEntityLookupComponent,
    SLEntityTypePipe,
    SLAddressPipe,
    SLSharePipe,
    SLAccountBalanceItemsPipe,
    SLMovementWritingDatePipe,

    SLEntityVersionListComponent,
    SLEntityVersionEditComponent,
    SLEntityVersionVerifyComponent,

    SLMovementEditComponent,
    SLMovementLineOperationPipe,
    SLMovementLineShareTypePipe,
    SLMovementLineOwnershipPipe,
    SLMovementLineNaturePipe,
    SLMovementRegisterComponent,
    SLMovementDismembermentDialogComponent,

    SLEntityFormComponent,
    SLEntityExtraFieldsFormComponent,
    SLEntityExtraFieldsPanelComponent,
    SLEntityDetailsComponent,
    SLEntityInfosComponent,
    SLEntityMovementsComponent,
    SLEntityBlockchainComponent,
    SLEntityMovementsLedgerComponent,
    SLEntityOwnedSharesComponent,
    SLEntityShareholdersComponent,
    SLEntityAttachmentsComponent,

    SLAuthorizationListComponent,
  ],
  exports: [
    SLEntityTypePipe,
    SLAddressPipe,
    SLSharePipe,
    SLAccountBalanceItemsPipe,
    SLAuthorizationListComponent,
    SLEntityLookupComponent,
  ],
  providers: [
    SLEntityService,
    SLEntityResolver,
    SLEntityVersionResolver,
    SLAttachmentService,
    SLAuthorizationService,
  ],
  bootstrap: [
    SLEntityFilterDialogComponent,
    SLEntitySearchDialogComponent,
    SLEntityNewDialogComponent,
    SLMovementDismembermentDialogComponent,
  ]
})
export class SLEntityModule { }
